import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EmailConfigurationComponent } from "./email-configuration/email-configuration.component";
import { HospitalManagerConfigurationComponent } from "./hospital-manager-configuration/hospital-manager-configuration.component";
import { patientBillingConfigurationComponent } from "./patient-billing-configuration/patient-billing-configuration.component";

import { SmsConfigurationComponent } from "./sms-configuration/sms-configuration.component";
import { InventoryConfigurationComponent } from "./inventory-configuration/inventory-configuration.component";

const routes: Routes = [
  {
    path: "hospitalManagerConfiguration",
    component: HospitalManagerConfigurationComponent,
  },
  { path: "email-configuration", component: EmailConfigurationComponent },
  {
    path: "patientbillingconfiguration",
    component: patientBillingConfigurationComponent,
  },
 
  {
    path: "smsconfiguration",
    component: SmsConfigurationComponent,
  },
  
    {
    path: "inventoryconfiguration",
    component: InventoryConfigurationComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConfigurationRoutingModule {}
